<ng-template #popTemplate>
  <p [innerHTML]="popoverMessage ? popoverMessage : 'Êtes-vous sûr ?'"></p>
  @if (cancelButton) {
    <button
      class="btn ea-{{ context }}-outline mrm"
      (click)="pop.hide(); cancel.emit()"
    >
      Annuler
    </button>
  }
  <button
    class="btn ea-{{ context }}-filled"
    (click)="pop.hide(); confirm.emit()"
  >
    Confirmer
  </button>
</ng-template>

<div
  [popover]="popTemplate"
  #pop="bs-popover"
  [outsideClick]="true"
  container="body"
>
  <div #customActionTemplate>
    <ng-content select="button"></ng-content>
  </div>
  @if (customActionTemplate.children.length == 0) {
    <div #defaultActionTemplate>
      <button>Supprimer</button>
    </div>
  }
</div>
